// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
/// табличка со значениями комисиий в зависимости от размера лота (from to)
import { CommissionOperationType } from '@shared/utils/Commission/CommissionEnums';
export class RevenueCommissionValueItem {
    constructor() {
        this.OperationType = null;
        this.FromAmount = null;
        this.ToAmount = null;
        this.minValue = 0.0;
        this.maxValue = 0.0;
        this.val = 0.0;
    }
    GetFixedCommissionValue(commission, ignoreMinMaxCorrection = false, markup = 1.0) {
        if (ignoreMinMaxCorrection) {
            return commission;
        }
        let fixedCommission = 0.0;
        if (this.minValue !== 0.0 && commission <= this.minValue) {
            // маркап не учитываем
            fixedCommission = this.minValue;
        }
        else if (this.maxValue !== 0.0 && commission >= this.maxValue) {
            // маркап не учитываем
            fixedCommission = this.maxValue;
        }
        else {
            fixedCommission = commission * markup; // а здесь уже учитываем маркап #45719
        }
        return fixedCommission;
    }
    GetCommission(param) {
        if (param.OperationType !== this.OperationType && this.OperationType !== CommissionOperationType.ALL) {
            return 0;
        }
        const amount = param.Lots;
        if (amount >= this.FromAmount && (amount < this.ToAmount || this.ToAmount === -1)) {
            return this.Value;
        }
        return 0;
    }
    GetLotsListForType(outLotsArray, operationType) {
        if (operationType === this.OperationType ||
            operationType === CommissionOperationType.ALL ||
            this.OperationType === CommissionOperationType.ALL) {
            // WTF проверить
            if (!outLotsArray.Contains(this.FromAmount)) {
                outLotsArray.push(this.FromAmount);
            }
        }
    }
    get Value() {
        return this.val;
    }
    set Value(value) {
        this.val = value;
    }
    get MinValue() {
        return this.minValue;
    }
    set MinValue(value) {
        this.minValue = value;
    }
    get MaxValue() {
        return this.maxValue;
    }
    set MaxValue(value) {
        this.maxValue = value;
    }
    get IsShort() {
        return this.OperationType === CommissionOperationType.SHORT;
    }
    get IsOpenOrClose() {
        return (this.OperationType === CommissionOperationType.OPEN || this.OperationType === CommissionOperationType.CLOSE);
    }
    get IsBuySellShort() {
        return (this.OperationType === CommissionOperationType.BUY ||
            this.OperationType === CommissionOperationType.SELL ||
            this.OperationType === CommissionOperationType.SHORT);
    }
}
